import _extend from 'lodash/extend';
import Utils from 'services/utils';
import Config from 'services/config/local';

/**
 * Alert class.
 */
export default class Alert {
    /**
     * @param {Object} data - Alert data
     * @constructor
     */
    constructor(data) {
        _extend(this, data);

        this.createdFormatted = Utils.convertTimestampToFormat(this.created, Config.format.datetime);
        this.endedFormatted = Utils.convertTimestampToFormat(this.ended, Config.format.datetime);
    }
}



// WEBPACK FOOTER //
// ./app/services/api/alerts/alert.class.js